import ModelUtil from '@leverege/model-util';
import StringUtil from '@leverege/string-util';
import { GlobalState } from '@leverege/ui-redux';
import { Project, System } from '@leverege/api-redux';
import { Attributes } from '@leverege/ui-attributes';
import { createImagineAggregationBuilder } from "../AggregationBuilder.js";
const imagineType = 'terms';
const TYPE = `aggregation.${imagineType}`;
const methods = {
  ...ModelUtil.createAllValue('field'),
  ...ModelUtil.createAllValue('fieldType'),
  ...ModelUtil.createAllValue('size'),
  ...ModelUtil.createAllArray('include'),
  ...ModelUtil.createAllArray('exclude'),
  ...ModelUtil.createAllValue('minCount'),
  ...ModelUtil.createAllValue('missing'),
  ...ModelUtil.createAllValue('order'),
  ...ModelUtil.createAllValue('showError'),
  ...ModelUtil.createAllValue('attrName')
};
function create() {
  return {
    type: TYPE,
    field: null,
    size: null,
    include: null,
    exclude: null,
    minCount: null,
    missing: null,
    order: null,
    showError: null,
    attrName: null
  };
}
function getValueType(model) {
  return 'buckets';
}
function formatBucketKey(bucket, value, options) {
  const {
    trueValue = 'True',
    falseValue = 'False'
  } = options || {};
  if (bucket.key === 1) {
    return trueValue;
  }
  if (bucket.key === 0) {
    return falseValue;
  }
  return bucket.key;
}
function formatBucketName(bucket, value, options) {
  const {
    attrName
  } = value;
  const {
    trueValue = 'True',
    falseValue = 'False',
    objectType,
    delegate
  } = options || {};
  if (bucket.key === 1) {
    return trueValue;
  }
  if (bucket.key === 0) {
    return falseValue;
  }
  const attribute = Attributes.getAttribute(attrName, objectType);
  if (attribute?.valueType === 'enum' || attribute?.valueType === 'resourceEnum') {
    const projectId = attribute?.source?.attribute?.blueprint?.model?.projectId;
    const systemId = delegate.systemId;
    const enumType = attribute?.blueprint?.attribute?.model?.enumType;
    const enumData = attribute.valueType === 'enum' ? Project(projectId).enum(enumType).getEnum(GlobalState.get()) : System(systemId).resourceEnum(enumType).getResourceEnum(GlobalState.get());
    if (enumData?.values) {
      return enumData.values.find(item => item.value === bucket.key)?.name || bucket.key;
    }
  }
  return bucket.key;
}
export default {
  create,
  TYPE,
  name: StringUtil.camelCaseToTitleCase(imagineType),
  ...methods,
  toImagineAgg: createImagineAggregationBuilder(imagineType),
  getValueType,
  formatBucketKey,
  formatBucketName
};